export default "__VITE_ASSET__VDgniabN__"